<template>
  <div id="page-user-view">
    <shipblu-card class="mb-base p-5"  :cardLoading="dataLoading">
      <p class="h4 mb-6">{{$t('BluCom')}}</p>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 flex items-center">
          <label class="font-semibold">{{$t('WhatsApp Communication')}}</label>
        </div>
        <div class="vx-col w-2/3">
          <vs-switch :disabled="!subscriptionEditable"  v-model="bluCom" class="mt-2"/>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 flex items-center">
          <label class="font-semibold">{{$t('Magic Link')}}</label>
        </div>
        <div class="vx-col w-2/3">
          <vs-switch :disabled="!subscriptionEditable" v-model="magicLink" class="mt-2"/>
        </div>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 flex items-center">
          <label class="font-semibold">{{$t('RTO Email')}}</label>
        </div>
        <div class="vx-col w-2/3">
          <vs-switch :disabled="!subscriptionEditable" v-model="rtoEmail" class="mt-2"/>
        </div>
        <p @click="resendMail()" v-if="($store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support') && (rtoEmail === true && !subscriptionEditable)" class="text-primary underline text-sm cursor-pointer px-4">{{$t('Resend RTO Email')}}</p>
      </div>
      <div class="vx-row mb-2">
        <div class="vx-col w-1/3 flex items-center">
          <label class="font-semibold">{{$t('RTO Hold')}}</label>
        </div>
        <div class="vx-col w-2/3">
          <vs-switch :disabled="!subscriptionEditable" v-model="rtoHold" class="mt-2"/>
        </div>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'customer-support' || $store.state.AppActiveUser.userRole === 'commercial-admin'" class="flex flex-wrap items-center justify-end mt-6">
        <vs-button class="ml-auto mt-2" v-if="!subscriptionEditable" @click="subscriptionEditable = true">{{$t('Edit')}}</vs-button>
        <vs-button class="ml-auto mt-2" v-if="subscriptionEditable" @click="updateMerchant()">{{$t('Save')}}</vs-button>
        <vs-button class="ml-4 mt-2" v-if="subscriptionEditable" @click="cancelEdit()" type="border" color="warning">{{$t('Cancel')}}</vs-button>
      </div>
    </shipblu-card>
  </div>
</template>

<script>
import {sendRequest} from '../../../http/axios/requestHelper'
import i18nData from '../../../i18n/i18nData.js'
import ShipbluCard from '../../../layouts/components/ShipbluCard.vue'

export default {
  data () {
    return {
      editable: false,
      subscriptionEditable: false,
      data: {},
      dataLoading: false,
      bluCom: false,
      magicLink: false,
      rtoEmail: false,
      rtoHold: false,
      oldPickupOrder: 0,
      oldPickupFees: 0
    }
  },
  methods: {
    getEgyptTime () {
      const egyptTimeZone = 'Africa/Cairo'
      const now = new Date()
      const daysOptions = { timeZone: egyptTimeZone, weekday: 'long' }
      const egyptDay = now.toLocaleDateString('en-US', daysOptions)

      const hoursOptions = { timeZone: egyptTimeZone, hour: '2-digit', minute: '2-digit', hour12: false }
      const egyptTime = now.toLocaleTimeString('en-US', hoursOptions)
      return [egyptTime, egyptDay]
    },
    cancelEdit () {
      this.editable = false
      this.subscriptionEditable = false
      this.loadMerchant()
    },
    loadMerchant () {
      this.dataLoading = true
      sendRequest(true, false, this, `api/v1/merchants/${this.$route.params.merchantID}/`, 'get', null, true,
        (response) => {
          this.data = response.data
          this.bluCom = this.data.blucomm_subscriptions[0].notification_channel === 'whatsapp'
          this.magicLink = this.data.blucomm_subscriptions[0].magic_link
          this.rtoEmail = this.data.blucomm_subscriptions[0].rto_email
          this.rtoHold = this.data.blucomm_subscriptions[0].rto_hold
          this.dataLoading = false
        } 
      )
    },
    updateMerchant () {
      this.dataLoading = true
      this.$validator.validateAll().then(result => {
        if (result) {
          const cashProcessing = {
            blucomm_subscriptions: [
              {
                notification_channel: this.bluCom ? 'whatsapp' : 'sms',
                magic_link: this.magicLink,
                rto_email: this.rtoEmail,
                rto_hold: this.rtoHold
              }
            ]
          }
          sendRequest(true, false, this, `api/v1/merchants/${this.$route.params.merchantID}/`, 'patch', cashProcessing, true,
            () => {
              this.dataLoading = false
              this.editable = false
              this.subscriptionEditable = false
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['Merchant'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
            }
          )
        }
      })
    },
    resendMail () {
      if ((Number(this.getEgyptTime()[0].split(':')[0]) >= 14) && this.getEgyptTime()[1] !== 'Friday') {
        sendRequest(true, false, this, `api/v1/merchants/${this.$route.params.merchantID}/send-rto/`, 'post', {}, true,
          () => {
            this.$vs.notify({
              color:'success',
              title:i18nData[this.$i18n.locale]['Success'],
              text:i18nData[this.$i18n.locale]['RTO Email has been resent successfully!'],
              position: 'top-center'
            })
          }
        )
      } else {
        this.$vs.notify({
          color:'warning',
          title: i18nData[this.$i18n.locale]['Warning'],
          text: 'RTO Email can be resent after 2 PM',
          position: 'top-center'
        })
      }
    }
  },
  components: {
    ShipbluCard
  },
  created () {
    this.loadMerchant()
  }
}
</script>